/*global REACT_APP_API_BASE_URL:true*/
import request from "@/utils/request";

export async function getAdminQuotes(_, params, quotesStatus) {
  let sorting = params.sorter ? params.sorter.split(":") : null;
  let filtering = params.filters ? params.filters : null;
  let paramsPayload = {
    PageNumber: params.current,
    PageSize: params.pageSize,
    status: quotesStatus,
  };
  if (sorting) {
    (paramsPayload.column = sorting[0]), (paramsPayload.order = sorting[1]);
  }
  if (filtering) {
    paramsPayload.filterBy = "";
    paramsPayload.filterValue = "";
    paramsPayload.filterCount = 0;

    filtering.forEach(filter => {
      paramsPayload.filterBy += `${filter.split(":")[0]}|`;
      paramsPayload.filterValue += `${filter.split(":")[1]}|`;
      paramsPayload.filterCount++;
    });

    paramsPayload.filterBy = paramsPayload.filterBy.slice(0, -1);
    paramsPayload.filterValue = paramsPayload.filterValue.slice(0, -1);
  }
  if (params.searchValue) {
    paramsPayload.search = params.searchValue.toLowerCase().trim();
  }
  const result = request(`${REACT_APP_API_BASE_URL}/api/Quotes/Admin`, {
    params: paramsPayload,
  });

  return await result;
}

export async function getSingleQuote(_, params) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Quotes/${params.vehicleId}`, {});

  return (await result)?.data;
}

export async function getSingleQuoteById(_, params) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Quotes/GetQuoteById?QuoteId=${params.quoteId}`, {});

  return (await result)?.data;
}

export async function getTAQQuote(_, payload) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Quotes/GetTAQQuote`, {
    method: "POST",
    data: payload,
  });

  if (result.data) {
    // Status field in TAQ api response body is typically 1001 for success
    if (result.data.Status === 1001) return result.data;

    return Promise.reject(result.data);
  }

  return Promise.reject("Error quoting vehicle.");
}

export async function submitTAQFeedback(_, payload, vehicleId) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Quotes/SubmitTAQFeedback`, {
    method: "POST",
    data: { ...payload, vehicleId },
  });

  return (await result)?.data;
}

export async function submitQuote(_, payload) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Quotes/Resolve`, {
    method: "PATCH",
    data: payload,
  });

  return (await result)?.data;
}

export async function pendingQuoteSubmit(_, payload) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Quotes/Pending`, {
    method: "PATCH",
    data: payload,
  });

  return (await result).data;
}

export async function editQuote(_, payload) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Quotes/Edit`, {
    method: "PATCH",
    data: payload,
  });

  return (await result)?.data;
}

export async function getPricingBands() {
  const result = request(`${REACT_APP_API_BASE_URL}/api/PricingBands`, {});

  return (await result).data;
}

export async function editPricingBand(_, payload) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/PricingBands/Edit`, {
    method: "PATCH",
    data: payload,
  });

  return result ? result : { error: true };
}

export async function addPricingBand(_, payload) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/PricingBands`, {
    method: "POST",
    data: payload,
  });

  return result ? result : { error: true };
}

export async function deletePricingBand(_, pricingBandId) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/PricingBands/${pricingBandId}`, {
    method: "DELETE",
  });

  return (await result).data;
}

export async function getPricingBandSettings(_, entityId) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/PricingBands/settings`, {
    params: { id: entityId },
  });

  return (await result).data;
}

export async function deleteQuote(_, payload) {
  const result = request(`${REACT_APP_API_BASE_URL}/api/Quotes/`, {
    params: payload,
    method: "DELETE",
  });

  return (await result).data;
}
